"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateOnNonWebkit = exports.splitQueryString = exports.isWebkitBrowser = exports.isSamsungInternet = exports.getFirstFocusableChild = exports.encodeQueryData = exports.deepmerge = exports.canUseDOM = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _deepmerge2 = _interopRequireDefault(require("deepmerge"));
var _count = _interopRequireDefault(require("../poly/count"));
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var getFirstFocusableChild = function getFirstFocusableChild(parent) {
  return parent.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
};
exports.getFirstFocusableChild = getFirstFocusableChild;
var isWebkitBrowser = function isWebkitBrowser() {
  return global.window !== undefined ? global.window.navigator.userAgent.search(/webkit/i) > 0 : false;
};
exports.isWebkitBrowser = isWebkitBrowser;
var isSamsungInternet = function isSamsungInternet() {
  return global.window !== undefined ? global.window.navigator.userAgent.match(/SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i) : false;
};
exports.isSamsungInternet = isSamsungInternet;
var truncateOnNonWebkit = function truncateOnNonWebkit(text, length) {
  if (!!text && !!length) {
    return isWebkitBrowser() || text.length <= length ? text : text.substring(0, length).concat('...');
  }
  return '';
};
exports.truncateOnNonWebkit = truncateOnNonWebkit;
var deepmerge = function deepmerge() {
  for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }
  return _deepmerge2.default.all(items.map(function (item) {
    return (0, _count.default)(item) === 0 ? {} : item;
  }));
};
exports.deepmerge = deepmerge;
var encodeQueryData = function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  }
  return ret.join('&');
};
exports.encodeQueryData = encodeQueryData;
var splitQueryString = function splitQueryString(url) {
  var query = {};
  if (!(0, _isString.default)(url)) return query;
  var urlParts = url.split('?');
  var queryParts = urlParts.pop().split('&');
  var _iterator = _createForOfIteratorHelper(queryParts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      var parts = part.split('=');
      var key = parts[0];
      var value = parts.pop();
      if (value === key) {
        query[decodeURIComponent(key)] = true;
      } else if (isNaN(value)) {
        query[decodeURIComponent(key)] = decodeURIComponent(value);
      } else {
        query[decodeURIComponent(key)] = parseInt(decodeURIComponent(value));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return query;
};
exports.splitQueryString = splitQueryString;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;